import { render, staticRenderFns } from "./coProjects.vue?vue&type=template&id=773ec514&scoped=true&"
import script from "./coProjects.vue?vue&type=script&lang=js&"
export * from "./coProjects.vue?vue&type=script&lang=js&"
import style0 from "./coProjects.vue?vue&type=style&index=0&id=773ec514&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773ec514",
  null
  
)

component.options.__file = "coProjects.vue"
export default component.exports